import { useCallback } from "react";
import * as Icons from 'react-icons/bs';
import { TLeaf } from "../../types";
import { DottedPlaceholder, EDottedPlaceholder } from "./DottedPlaceholder";
import { useDocuments } from "../../contexts/DekstopContext";

export const TreeLeaf = (leaf: TLeaf & { last?: boolean, fetcher?: (...props: any) => any }) => {
    const { openDocument } = useDocuments();

    const handleClick = useCallback(async () => {
        openDocument({ id: leaf.data._id, title: leaf.data.title });
    }, [leaf.data._id, leaf.data.title, openDocument]);

    return (
        <div className='lint-tree-leaf'>
            <div className='lint-tree-leaf-header' onClick={handleClick}>
                <DottedPlaceholder type={leaf.last ? EDottedPlaceholder.LEAF_LAST : EDottedPlaceholder.LEAF} />
                <div><Icons.BsFileEarmarkTextFill className='collapsible-file-icon align-self-center lint-tree-icon' /></div>
                <div className='lint-tree-text text-ellipsis'>{`${leaf.data.nr}/${leaf.data.year} - ${leaf.data.title}`}</div>
            </div>
        </div>
    )
}
